<template>
  <div id="app" v-if="ready">
    <m-head :ua="ua" :login="login"></m-head>
    <m-view></m-view>
  </div>
</template>

<script>
import m_head from '@/components/head.vue';
import m_view from '@/components/body.vue';

import "./assets/css/main.css";

export default {
  name: 'App',
  components : {
    'm-head' : m_head,
    'm-view' : m_view,
  },
  props : {
    ready : {
      default : false,
    },
    ua : {
      default : () => {},
    },
    login : {
      default : 0,
    }    
  },
}
</script>

<style scoped>
  #app{
    position: relative;
    max-width: 1920px;
    height: 7500px;
    margin: 0 auto;
    background-image: url(./assets/images/body.jpg);
    background-position: center top;
    background-repeat: no-repeat;    
    background-color: #222229;
    overflow-x: hidden;    
  }  
</style>



// WEBPACK FOOTER //
// src/App.vue